// London Smoke & Cure — wholesale cart shipping (single source of truth).

export const FREE_SHIPPING_THRESHOLD_GBP = 150;
export const FLAT_SHIPPING_CHARGE_GBP = 8.95;

/** Round to pence so £149.999… / display drift does not flip shipping at checkout. */
export function roundMoneyGbp(amount) {
    const n = Number(amount);
    if (!Number.isFinite(n)) return 0;
    return Math.round((n + Number.EPSILON) * 100) / 100;
}

export function calculateCartSubtotalGbp(lineItems) {
    const sum = (lineItems || []).reduce(
        (acc, item) => acc + Number(item?.price || 0) * Number(item?.quantity || 0),
        0
    );
    return roundMoneyGbp(sum);
}

export function isPricingTierBFreeShipping(pricingKey) {
    return String(pricingKey || '').trim().toUpperCase() === 'B';
}

/**
 * Wholesale shipping for cart checkout and order submission.
 * @returns {{ subtotalGbp: number, shippingCharge: number, shippingReason: string|null, isFreeShipping: boolean }}
 */
export function calculateWholesaleShipping({
    subtotal,
    isCollection = false,
    pricingKey,
} = {}) {
    const subtotalGbp = roundMoneyGbp(subtotal);

    if (isCollection) {
        return {
            subtotalGbp,
            shippingCharge: 0,
            shippingReason: 'Collection',
            isFreeShipping: true,
        };
    }

    if (isPricingTierBFreeShipping(pricingKey)) {
        return {
            subtotalGbp,
            shippingCharge: 0,
            shippingReason: 'Pricing B',
            isFreeShipping: true,
        };
    }

    if (subtotalGbp >= FREE_SHIPPING_THRESHOLD_GBP) {
        return {
            subtotalGbp,
            shippingCharge: 0,
            shippingReason: 'Over £150',
            isFreeShipping: true,
        };
    }

    return {
        subtotalGbp,
        shippingCharge: FLAT_SHIPPING_CHARGE_GBP,
        shippingReason: null,
        isFreeShipping: false,
    };
}

/**
 * Convenience: line items → subtotal + shipping in one call (use at order submit).
 */
export function calculateWholesaleShippingFromCart({
    lineItems,
    isCollection = false,
    pricingKey,
} = {}) {
    const subtotalGbp = calculateCartSubtotalGbp(lineItems);
    const shipping = calculateWholesaleShipping({ subtotal: subtotalGbp, isCollection, pricingKey });
    return {
        ...shipping,
        orderTotalGbp: roundMoneyGbp(subtotalGbp + shipping.shippingCharge),
    };
}
